import { uniqBy, prop } from 'ramda';
import { useEffect, useRef, useState } from 'react';
const createSelectedIdsSet = (selectedIds) => {
    const set = new Set();
    Object.entries(selectedIds).forEach(([key, value]) => {
        if (value) {
            set.add(key);
        }
    });
    return set;
};
export const isEqualSelectedIds = (object1, object2) => {
    const set1 = createSelectedIdsSet(object1);
    const set2 = createSelectedIdsSet(object2);
    if (set1.size !== set2.size) {
        return false;
    }
    return [...set1].every((key) => set2.has(key));
};
export const useSelectedRowsSync = (externalSelectedRowIds, tableInstance) => {
    const [state, setState] = useState({
        selectedFlatRows: tableInstance.selectedFlatRows,
        selectedRowIds: tableInstance.state.selectedRowIds
    });
    const stateRef = useRef(state);
    stateRef.current = state;
    // used ref to avoid effect looping
    const selectedRowIdsRef = useRef(tableInstance.state.selectedRowIds);
    selectedRowIdsRef.current = tableInstance.state.selectedRowIds;
    useEffect(() => {
        const selectedRowIdsCopy = { ...selectedRowIdsRef.current };
        Object.entries(externalSelectedRowIds).forEach(([id, isSelected]) => {
            if (selectedRowIdsRef.current[id] == null || selectedRowIdsRef.current[id] !== isSelected) {
                tableInstance.toggleRowSelected(id, isSelected);
                selectedRowIdsCopy[id] = isSelected;
            }
        });
        Object.entries(selectedRowIdsCopy).forEach(([id, isSelected]) => {
            if (externalSelectedRowIds[id] == null) {
                tableInstance.toggleRowSelected(id, false);
            }
            else if (externalSelectedRowIds[id] !== isSelected) {
                tableInstance.toggleRowSelected(id, externalSelectedRowIds[id]);
            }
        });
    }, [externalSelectedRowIds]);
    const externalSelectedRowIdsRef = useRef(externalSelectedRowIds);
    externalSelectedRowIdsRef.current = externalSelectedRowIds;
    useEffect(() => {
        if (!isEqualSelectedIds(tableInstance.state.selectedRowIds, externalSelectedRowIdsRef.current)) {
            const selectedFlatRows = [...stateRef.current.selectedFlatRows].filter((row) => tableInstance.state.selectedRowIds[row.id]);
            setState({
                selectedFlatRows: uniqBy(prop('id'), [
                    ...selectedFlatRows,
                    ...tableInstance.selectedFlatRows
                ]),
                selectedRowIds: tableInstance.state.selectedRowIds
            });
        }
    }, [tableInstance.state.selectedRowIds, setState]);
    return state;
};
